import * as types from '../actions';

const initialState = {  
    status:0,
    activity:'',
    errorData:'',  
    timesheet:[],
    timesheetTotalPage:0,
    timesheetNumRows:0,
    timesheetCount:0,
    timesheetCSV:'',
    timesheetSummaryCSV:'',
    getActionNeeded:true
}

export default function(state = initialState, action) {
    const localResponse = action.data;
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.TIMESHEET_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = 1
                if(response.data.results !== undefined){
                    totalPage = Math.ceil(response.data.count/response.data.page_size);
                }
                return {
                    ...state, 
                    timesheet:(response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,  
                    activity:types.TIMESHEET_LIST_SUCCESS+timeVar,           
                    timesheetTotalPage: (response.data.results === undefined ? 1 : totalPage),
                    timesheetNumRows:(response.data.results === undefined ? response.data.length : response.data.results.length),
                    timesheetCount:response.data.count                             
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.TIMESHEET_LIST_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }     
        case types.SET_ACTION_NEEEDED: 
            return {
              ...state,
              getActionNeeded:localResponse
            };
        case types.TIMESHEET_DETAILS_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetDetails:response.data ? response.data.data : [],
                    status: response.status,  
                    activity:types.TIMESHEET_DETAILS_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.TIMESHEET_DETAILS_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }      
            
        case types.TIMESHEET_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    status: response.status,  
                    activity:types.TIMESHEET_UPDATE_SUCCESS+timeVar,                               
                };
            }
            else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.TIMESHEET_UPDATE_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }     
        
        case types.TIMESHEET_FILTER_EVENTS_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetFilterEventsList:response.data,
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_EVENTS_SUCCESS+timeVar, 
                };
            }
            else {
                return {
                    ...state, 
                    timesheetFilterErrorData:response.data,                              
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_EVENTS_ERROR+timeVar, 
                };
            }
        case types.TIMESHEET_FILTER_EVENTS_ERROR:
            return {
                ...state, 
                timesheetFilterErrorData: response && response.data && response.data.length>0?response.data:[], 
                timesheetFilterStatus: (response && response.status) ? response.status : '',  
                timesheetFilterActivity:types.TIMESHEET_FILTER_EVENTS_ERROR+timeVar, 
            };

        case types.TIMESHEET_FILTER_LOCATION_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetFilterLocationsList:response.data,
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_LOCATION_SUCCESS+timeVar, 
                };
            }
            else {
                return {
                    ...state, 
                    timesheetFilterErrorData:response.data,                              
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_LOCATION_ERROR+timeVar, 
                };
            }
        case types.TIMESHEET_FILTER_LOCATION_ERROR:
            return {
                ...state, 
                timesheetFilterErrorData: response && response.data && response.data.length>0?response.data:[], 
                timesheetFilterStatus: (response && response.status) ? response.status : '',  
                timesheetFilterActivity:types.TIMESHEET_FILTER_LOCATION_ERROR+timeVar, 
            };

        case types.TIMESHEET_FILTER_CREW_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetFilterCrewsList:response.data,
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_CREW_SUCCESS+timeVar, 
                };
            }
            else {
                return {
                    ...state, 
                    timesheetFilterErrorData:response.data,                              
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_CREW_ERROR+timeVar, 
                };
            }
        case types.TIMESHEET_FILTER_CREW_ERROR:
            return {
                ...state, 
                timesheetFilterErrorData: response && response.data && response.data.length>0?response.data:[], 
                timesheetFilterStatus: (response && response.status) ? response.status : '',  
                timesheetFilterActivity:types.TIMESHEET_FILTER_CREW_ERROR+timeVar, 
            };

        case types.TIMESHEET_FILTER_SKILL_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetFilterSkillsList:response.data,
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_SKILL_SUCCESS+timeVar, 
                };
            }
            else {
                return {
                    ...state, 
                    timesheetFilterErrorData:response.data,                              
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_SKILL_ERROR+timeVar, 
                };
            }
        case types.TIMESHEET_FILTER_SKILL_ERROR:
            return {
                ...state, 
                timesheetFilterErrorData: response && response.data && response.data.length>0?response.data:[], 
                timesheetFilterStatus: (response && response.status) ? response.status : '',  
                timesheetFilterActivity:types.TIMESHEET_FILTER_SKILL_ERROR+timeVar, 
            };

        case types.TIMESHEET_FILTER_DEPARTMENT_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetFilterDepartmentsList:response.data,
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_DEPARTMENT_SUCCESS+timeVar, 
                };
            }
            else {
                return {
                    ...state, 
                    timesheetFilterErrorData:response.data,                              
                    timesheetFilterStatus: response.status,  
                    timesheetFilterActivity:types.TIMESHEET_FILTER_DEPARTMENT_ERROR+timeVar, 
                };
            }
        case types.TIMESHEET_FILTER_DEPARTMENT_ERROR:
            return {
                ...state, 
                timesheetFilterErrorData: response && response.data && response.data.length>0?response.data:[], 
                timesheetFilterStatus: (response && response.status) ? response.status : '',  
                timesheetFilterActivity:types.TIMESHEET_FILTER_DEPARTMENT_ERROR+timeVar, 
            };
        
        case types.TIMESHEET_SHIFT_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = 1
                if(response.data.results !== undefined){
                    totalPage = Math.ceil(response.data.count/response.data.page_size);
                }
                return {
                    ...state, 
                    timesheet:(response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,  
                    activity:types.TIMESHEET_SHIFT_LIST_SUCCESS+timeVar,           
                    timesheetTotalPage: (response.data.results === undefined ? 1 : totalPage),
                    timesheetNumRows:(response.data.results === undefined ? response.data.length : response.data.results.length),
                    timesheetCount:response.data.count                             
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.TIMESHEET_SHIFT_LIST_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }  
        case types.TIMESHEET_SHIFT_LIST_ERROR:
            return {
                ...state,  
                status: response.status,  
                activity:types.TIMESHEET_SHIFT_LIST_ERROR+timeVar, 
                errorData:response.data                              
            };

        case types.TIMESHEET_CSV_DOWNLOAD_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetCSV:(response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,  
                    activity:types.TIMESHEET_CSV_DOWNLOAD_SUCCESS+timeVar,                                 
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.TIMESHEET_CSV_DOWNLOAD_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }  
        case types.TIMESHEET_CSV_DOWNLOAD_ERROR:
            return {
                ...state,  
                status: response.status,  
                activity:types.TIMESHEET_CSV_DOWNLOAD_ERROR+timeVar, 
                errorData:response.data                              
            };
        case types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_SUCCESS:
            if(response.status===200){
                return {
                    ...state, 
                    timesheetSummaryCSV:(response.data.results === undefined ? response.data : response.data.results),
                    status: response.status,  
                    activity:types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_SUCCESS+timeVar,                                 
                };                
            }else {
                return {
                    ...state,  
                    status: response.status,  
                    activity:types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_ERROR+timeVar, 
                    errorData:response.data                              
                };
            }  
        case types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_ERROR:
            return {
                ...state,  
                status: response.status,  
                activity:types.TIMESHEET_SUMMARY_CSV_DOWNLOAD_ERROR+timeVar, 
                errorData:response.data                              
            };

        




        case types.CLEAR:
            return {
                ...state,
                status:0,
                activity:types.CLEAR,
            } 
                
        default:
            return state;

    }
}